import template from 'text!./accounts-table.html';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures'; // PSA

export default [() => {
    return {
        restrict: 'EA',
        template: template,
        scope: {
            accounts: '=',
            noResultsMessage: '@'
        },
        controller: ['$scope', ($scope) => {
            $scope.activitiesTurnedOnPSA = ApplicationFeatures.getAllFeatures().disableActivities_PSA !== 'true'; // PSA
        }],

    };
}];